export function sortWithOrderArray(arr, order, 
/**
 *
 * The array can contain items which are not listed in the order array.
 * So sortUnorderedItems decides whether to leave these items untouched
 * in the current order in which they are in the array (sortUnorderedItems: false)
 * or to sort them using normal comparison rules
 */
{ sortUnorderedItems: sortUnorderedItems }) {
    const itemsToIndex = arr.reduce((acc, x, i) => {
        acc.set(x, i);
        return acc;
    }, new Map());
    const orderItemsToIndex = order.reduce((acc, x, i) => {
        acc.set(x, i);
        return acc;
    }, new Map());
    function compareItemsOfCustomSort(valueA, valueB) {
        const orderContainsFirstElement = orderItemsToIndex.has(valueA);
        const indexInOrderOfFirstElement = orderContainsFirstElement
            ? orderItemsToIndex.get(valueA)
            : -1;
        const orderContainsSecondElement = orderItemsToIndex.has(valueB);
        const indexInOrderSecondElement = orderContainsSecondElement
            ? orderItemsToIndex.get(valueB)
            : -1;
        //if none of the element are in the order list we just return normal compare
        if (!orderContainsFirstElement && !orderContainsSecondElement) {
            if (!sortUnorderedItems) {
                // keep the original order
                return itemsToIndex.get(valueA) - itemsToIndex.get(valueB);
            }
            if (valueA == valueB) {
                return 0;
            }
            return valueA < valueB ? -1 : 1;
        }
        //if first item not in the list make sure we put it after the second item
        if (!orderContainsFirstElement) {
            return 1;
        }
        //if second item not in the list make sure we put it after the first item
        if (!orderContainsSecondElement) {
            return -1;
        }
        //return the comparison from the list if the two items are in the list
        return indexInOrderOfFirstElement - indexInOrderSecondElement;
    }
    return [].concat(arr).sort(compareItemsOfCustomSort);
}
